export const selectFilteringHelper = (input: any, option: any) => {
  const childrenString: string = (option?.props?.children) || "";

  const matchingOption = childrenString
    .toLowerCase()
    .indexOf((input as string)
      .toLowerCase()) >= 0;
  return matchingOption;
};
